module.exports = __webpack_public_path__ + "static/media/antlatic_celtic_icon_medium.0487e6df.png";